module.exports = __webpack_public_path__ + "img/en.8403eb0.png";